// extracted by mini-css-extract-plugin
module.exports = {"offerHeadline":"styles_offerHeadline__HntUM","urgencyBadge":"styles_urgencyBadge__Om2Xl"};